import { render, staticRenderFns } from "./UcContractProtocolHeader.yaml?vue&type=template&id=7f05f426&component"
import script from "./UcContractProtocolHeader.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractProtocolHeader.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports